<template src="./index.html">
</template>

<script>
	import {getdata} from "./data.js";
	import cqgqtz from'./cqgqtz/index.vue'
	import zgfl from'./zgfl/index.vue'
	import uploadFile from '../../../common/uploadFile/index.vue'
	export default {
		components:{
			cqgqtz,zgfl,uploadFile
		},
		data() {
			return {
				searchdata:getdata().searchdata,
				searchlist:getdata().searchlist,
				shaidiag:false,
				headData:getdata().headData,
				tableData:getdata().tableData,
				updataItem:{},
				outlist:[],
				upformdata:null,
				tablekey:0,
				overlength:0,
				filediag:false,
				chooseindex:"",
				detaildata:[],
				showbox:{
					cqgqtz:false,
					zgfl:false,
					zgfltitle:""
				},
				cycle:[
					{
						value:"3",
						label:'按年'
					},
					{
						value:"2",
						label:'按季'
					},
					{
						value:"1",
						label:'按月'
					}
				],
				userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
			}
		},
		created() {
			this.searchlist[0].selectval=this.searchlist[0].selectval.filter(item=>item.label!=this.userInfo.deptName)
			this.searchlist[0].selectval.unshift({
				label:this.userInfo.deptName,
				value:this.userInfo.deptName
			})
			let arr=JSON.parse(JSON.stringify(this.searchlist))
			this.searchlist=arr
			this.searchdata.nsrmc=this.userInfo.deptName
			this.tableData=this.$getSzBankStorage('yjxsxtztableData')||getdata().tableData
		},
		mounted() {
		
		},
		methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
			getAmountTal(val){
				let total=0
					if(val.detaildata&&this.$notemptyandnull(val.detaildata)){
						val.detaildata.forEach(gtem=>{
							total+=parseFloat(gtem.AmountA||0)
						})
					}
				return total
			},
			getTaxAmount(val){
				let total=0
					if(val.detaildata&&this.$notemptyandnull(val.detaildata)){
						val.detaildata.forEach(gtem=>{
							total+=parseFloat(gtem.TaxAmount||0)
						})
					}
				return total
			},
			getdetaildata(data){
				this.tableData[this.chooseindex].detaildata=data
				let newarr= JSON.parse(JSON.stringify(this.tableData))
				this.tableData=newarr
				this.$message.success("操作成功")
				this.$setSzBankStorage('yjxsxtztableData',this.tableData)
					// this.showbox.cqgqtz=false
					// this.showbox.zgfl=false
			},
			//文件导入
			file_import(){
				this.filediag = true
				this.upformdata = {
				  upfilename: "",
				  upfile: "",
				  filestate: "",
				  filetype: "",
				  filesize: "",
				}
			},
			//获取上传文件流
			getuploadparams(){
				this.upformdata = e;
			},
			//下载标准模板
			fordownloadmb(){
				
			},
			//确认上传文件
			forupload(){
				
			},
			//编辑保存
			preservation(e){
				e.updata = false
				this.$setSzBankStorage('yjxsxtztableData',this.tableData)
			},
			//返回
			forback(e){
				Object.keys(this.showbox).map(key=>{
					if(this.showbox[key]){
						this.showbox[key] = false
					}
				})
			},
			//点击明细
			detailed(e,index){
				this.chooseindex=index
				this.detaildata=this.tableData[this.chooseindex].detaildata||[]
				if(e.project==3){
					this.showbox.cqgqtz=true
				}
				if([4,5,6,7,8,9].includes(e.project)){
					this.$projectlist.forEach(item=>{
						if(item.value==e.project){
							this.showbox.zgfltitle=item.label
						}
					})
					this.showbox.zgfl=true
				}
			},
			//编辑
			editOpen(e){
				let state=false
				this.tableData.forEach(item=>{
					if(item.updata){
						state=true
					}
				})
				if(state){
					this.$message.error("存在未保存的数据，请保存后再编辑")
					return false
				}
				this.updataItem = JSON.parse(JSON.stringify(e))
				e.updata = true
			},
			canceOpen(index){
				this.tableData[index]=JSON.parse(JSON.stringify(this.updataItem))
				this.tableData[index].updata = false
				let newarr=JSON.parse(JSON.stringify(this.tableData))
				this.tableData=newarr
			},
			//删除行/添加行
			addRows(e){
				let num = e+1
				this.tableData.splice(num,0,{
					Serial:'',
					project:'',
					ProjectD:'',
					cycle:'',
					shuikssqq:'',
					shuikssqz:'',
					AmountC:'',
					TaxAmount:'',
					IncreaseA:'',
					DecreaseA:'',
					prop1:'',
					prop2:'',
					prop3:'',
					updata:false,
				})
				this.updataItem = JSON.parse(JSON.stringify(this.tableData[num]))
				this.$setSzBankStorage('yjxsxtztableData',this.tableData)
			},
			DeleteRows(e){
				this.tableData.splice(e,1)
				this.$setSzBankStorage('yjxsxtztableData',this.tableData)
			},
			//搜索
			submitSearch(){
				this.tableData=this.$getSzBankStorage('yjxsxtztableData')||getdata().tableData
				this.$emptyandnull(this.searchdata.year)?this.searchdata.year="2023":''
				this.$emptyandnull(this.searchdata.nsrmc)?this.searchdata.nsrmc=this.userInfo.deptName:''
				this.searchdata.year!="2023"||this.searchdata.nsrmc!=this.userInfo.deptName?this.tableData=[]:''
				for (let key in this.searchdata) {
					if(this.$notemptyandnull(this.searchdata[key])&&key!="year"&&key!="nsrmc"){
						 if(key=='shuikssq'){
						 	this.tableData=this.tableData.filter(item=>item.shuikssqq>=this.searchdata.shuikssq[0]&&item.shuikssqz<=this.searchdata.shuikssq[1])
						 }else{
							 this.tableData=this.tableData.filter(item=>this.$notemptyandnull(item[key])&&item[key]==this.searchdata[key])
						 }
					}
				}
			},
			confirmfilter(e) {
			  this.headData = e.chooselist;
			  this.outlist = e.nochooselist;
			  this.shaidiag = false;
			},
			closeshaidiag() {
			  this.shaidiag = false;
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('index.less');
</style>
